export const SET_LOCATIONS = 'SET_LOCATIONS';
export const CLEAR_LOCATIONS = 'CLEAR_LOCATIONS';
export const GET_LOCATIONS = 'GET_LOCATIONS';
